import { render, staticRenderFns } from "./SettingsLabelSets.vue?vue&type=template&id=3ffa47c8&scoped=true"
import script from "./SettingsLabelSets.vue?vue&type=script&lang=js"
export * from "./SettingsLabelSets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa47c8",
  null
  
)

export default component.exports